import { styled, RadioGroup } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
import FormControlLabel from "../../external/@mui/material/FormControlLabel/FormControlLabel.js";
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: "0",
  ".MuiFormControlLabel-label": {
    color: theme.palette.grey[800]
  },
  "&.Mui-disabled": {
    color: theme.palette.grey[400]
  }
})), StyledRadioGroup = styled(RadioGroup)({
  position: "relative",
  display: "flex",
  gap: "12px 24px"
}), MessageStyled = styled(
  "span",
  shouldNotForwardProps(["isError"])
)(({ theme, isError }) => ({
  color: isError ? theme.palette.error.main : theme.palette.grey[500],
  fontWeight: "500",
  fontSize: "12px",
  lineHeight: "16px",
  marginTop: "12px"
})), RadioMessageStyled = styled(
  MessageStyled,
  shouldNotForwardProps(["isError"])
)(({ theme, isError }) => ({
  color: isError ? theme.palette.error.main : theme.palette.grey[500],
  marginLeft: "28px",
  marginTop: "8px",
  fontSize: "14px",
  lineHeight: "18px"
}));
export {
  MessageStyled,
  RadioMessageStyled,
  StyledFormControlLabel,
  StyledRadioGroup
};
//# sourceMappingURL=styles.js.map
